function getAuthHeaders() {
      return {
        'x-api-key': 'yoddha-service',
        Authorization: JSON.parse(localStorage.getItem('ims-token') || ''),
        'Content-Type': 'application/json',
      }
}

export default getAuthHeaders;